import React from 'react'
import { Breadcrumbs, Columns, Route, Rows } from 'labguard-cdk'
import { PageOptionsTarget, HomeIcon } from 'src/components/common'
import GroupSidebar from './GroupSidebar'
import TopNavbar from './TopNavbar'
import Groups from './Groups'
import Channels from './Channels'
import styles from './App.scss'
import Alarms from './Alarms'
import SystemAlarms from './SystemAlarms'
import AuditTrail from './AuditTrail'
import Users from './Users'
import Account from './Account'
import Charts from './Charts'
import SystemSettings from './SystemSettings'
import Duties from './Duties'
import Home from './Home'

const App = () => (
  <Columns className={styles.app} layout="auto 1" gap="0">
    <GroupSidebar />
    <Rows layout="auto 1" gap="0">
      <TopNavbar />
      <Rows className={styles.views} layout="auto 1">
        <Columns layout="auto 1">
          <Breadcrumbs />
          <PageOptionsTarget />
        </Columns>
        <Route breadcrumb={{ i18n: 'WEB_HOME', icon: HomeIcon }} component={Home}>
          <Route path="/users" component={Users} />
          <Route path="/groups" component={Groups} />
          <Route path="/channels" component={Channels} />
          <Route path="/channel-alarms" component={Alarms} />
          <Route path="/system-alarms" component={SystemAlarms} />
          <Route path="/audit-trail" component={AuditTrail} />
          <Route path="/charts" component={Charts} />
          <Route path="/account" component={Account} />
          <Route path="/system-settings" component={SystemSettings} />
          <Route path="/duties" component={Duties} />
        </Route>
      </Rows>
    </Rows>
  </Columns>
)

export default App
